// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderButton_headerButton__a6Xoj {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  column-gap: 8px;
  margin-left: 24px;
  border: 1px solid #E5E6EE;
  border-radius: 8px;
  padding: 5px 8px;
  background: transparent;
  transition: all 0.3s;
  text-align: left;
  cursor: pointer;
}
.HeaderButton_headerButton__a6Xoj:hover {
  border: 1px solid transparent;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 0 6px 0 rgba(0, 0, 0, 0.02);
}
.HeaderButton_headerButton__a6Xoj svg {
  grid-row: 1/3;
}
.HeaderButton_headerButton__a6Xoj .HeaderButton_title__Cp-3h {
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
}
.HeaderButton_headerButton__a6Xoj .HeaderButton_appeal__u4NAX {
  margin-top: 3px;
  font-size: 11px;
  line-height: 13px;
  color: #4778EE;
}

@media (max-width: 1000px) {
  .HeaderButton_root__-YvLG + .HeaderButton_root__-YvLG {
    display: none;
  }
}
@media (max-width: 825px) {
  .HeaderButton_root__-YvLG {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/buttons/HeaderButton/HeaderButton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gCAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,6BAAA;EACA,0EAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFJ;;AAMA;EACE;IACE,aAAA;EAHF;AACF;AAMA;EACE;IACE,aAAA;EAJF;AACF","sourcesContent":[".headerButton {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-template-rows: auto auto;\n  column-gap: 8px;\n  margin-left: 24px;\n  border: 1px solid #E5E6EE;\n  border-radius: 8px;\n  padding: 5px 8px;\n  background: transparent;\n  transition: all .3s;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover {\n    border: 1px solid transparent;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 0 6px 0 rgba(0, 0, 0, 0.02);\n  }\n\n  svg {\n    grid-row: 1 / 3;\n  }\n\n  .title {\n    font-size: 12px;\n    line-height: 14px;\n    color: #272A36;\n  }\n\n  .appeal {\n    margin-top: 3px;\n    font-size: 11px;\n    line-height: 13px;\n    color: #4778EE;\n  }\n}\n\n@media (max-width: 1000px) {\n  .root + .root {\n    display: none;\n  }\n}\n\n@media (max-width: 825px) {\n  .root {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerButton": `HeaderButton_headerButton__a6Xoj`,
	"title": `HeaderButton_title__Cp-3h`,
	"appeal": `HeaderButton_appeal__u4NAX`,
	"root": `HeaderButton_root__-YvLG`
};
export default ___CSS_LOADER_EXPORT___;
